import { i18n } from '../../i18n/translate.js';

var homeroomTeacherLeft = function homeroomTeacherLeft(environment) {
  var MENU_DOMAIN_FOR_FRONT_END = environment.MENU_DOMAIN_FOR_FRONT_END;
  return {
    id: 'foundry--universal_navigation--menus--homeroom_teacher_left',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--homeroom_teacher_left',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    submenu_items: [{
      id: '',
      slug: '',
      title: i18n.t('Explore Courses'),
      icon: 'file',
      css_class: '',
      target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/teacher/explore_courses"),
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [],
      weight: 100
    }, {
      id: '',
      slug: '',
      title: i18n.t('My Classes'),
      icon: 'users',
      css_class: '',
      target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/teacher/my_classes"),
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [],
      weight: 100
    }, {
      id: '',
      slug: '',
      title: i18n.t('Refer a Colleague'),
      icon: 'paper-plane',
      css_class: '',
      target_url: "".concat(MENU_DOMAIN_FOR_FRONT_END, "/teacher/invite_a_teacher"),
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [],
      weight: 100
    }]
  };
};

export { homeroomTeacherLeft };